import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const TermsOfServicePage = () => {
  return (
    <div className="min-h-screen bg-gray-950 pt-20">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Back Link */}
        <Link to="/" className="inline-flex items-center text-gray-400 hover:text-white mb-8">
          <ArrowLeft className="w-4 h-4 mr-2" />
          Back to Home
        </Link>

        <h1 className="text-4xl font-bold text-white mb-8">Terms of Service</h1>
        <p className="text-gray-400 mb-8">Last updated: February 11, 2026</p>

        <div className="prose prose-invert max-w-none space-y-8">
          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">1. Agreement to Terms</h2>
            <p className="text-gray-300 leading-relaxed">
              By accessing or using Life Decoder's website and services, you agree to be bound by these Terms 
              of Service. If you disagree with any part of these terms, you may not access our services.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">2. Description of Services</h2>
            <p className="text-gray-300 leading-relaxed">
              Life Decoder provides online courses, educational content, and consultation services related to 
              Chinese Metaphysics, including but not limited to BaZi, Feng Shui, Qi Men Dun Jia, and Numerology. 
              Our services are for educational and entertainment purposes.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">3. User Accounts</h2>
            <p className="text-gray-300 leading-relaxed mb-4">When creating an account, you agree to:</p>
            <ul className="list-disc list-inside text-gray-300 space-y-2 ml-4">
              <li>Provide accurate and complete information</li>
              <li>Maintain the security of your account credentials</li>
              <li>Accept responsibility for all activities under your account</li>
              <li>Notify us immediately of any unauthorized access</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">4. Course Access and Usage</h2>
            <p className="text-gray-300 leading-relaxed mb-4">Upon purchasing a course:</p>
            <ul className="list-disc list-inside text-gray-300 space-y-2 ml-4">
              <li>You receive a personal, non-transferable license to access the course content</li>
              <li>You may not share, distribute, or resell course materials</li>
              <li>Access is granted for the duration specified at purchase</li>
              <li>We reserve the right to modify or discontinue courses with notice</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">5. Consultation Services</h2>
            <p className="text-gray-300 leading-relaxed">
              Our consultation services provide guidance based on Chinese Metaphysics principles. These services 
              are for informational and educational purposes only and should not be considered as professional 
              advice for financial, medical, legal, or other professional matters.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">6. Payment Terms</h2>
            <p className="text-gray-300 leading-relaxed mb-4">
              All payments are processed securely through our payment providers. By making a purchase:
            </p>
            <ul className="list-disc list-inside text-gray-300 space-y-2 ml-4">
              <li>You authorize us to charge your payment method</li>
              <li>Prices are subject to change without notice</li>
              <li>All fees are non-refundable unless otherwise stated</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">7. Refund Policy</h2>
            <p className="text-gray-300 leading-relaxed">
              We offer a 30-day money-back guarantee on course purchases. Consultation services are 
              non-refundable once the session has been conducted. To request a refund, contact our 
              support team within the eligible period.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">8. Intellectual Property</h2>
            <p className="text-gray-300 leading-relaxed">
              All content on Life Decoder, including text, graphics, logos, videos, and course materials, 
              is our property or the property of our licensors and is protected by intellectual property laws. 
              Unauthorized use may violate copyright, trademark, and other laws.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">9. Disclaimer of Warranties</h2>
            <p className="text-gray-300 leading-relaxed">
              Our services are provided "as is" without warranties of any kind. We do not guarantee that our 
              services will meet your specific requirements or that results from using our services will be 
              accurate or reliable.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">10. Limitation of Liability</h2>
            <p className="text-gray-300 leading-relaxed">
              Life Decoder shall not be liable for any indirect, incidental, special, consequential, or 
              punitive damages resulting from your use of our services.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">11. Changes to Terms</h2>
            <p className="text-gray-300 leading-relaxed">
              We reserve the right to modify these terms at any time. We will notify users of significant 
              changes via email or website notice. Continued use after changes constitutes acceptance of 
              the modified terms.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">12. Contact Information</h2>
            <p className="text-gray-300 leading-relaxed">
              For questions about these Terms of Service, please contact us at:
            </p>
            <p className="text-gray-300 mt-4">
              <strong className="text-white">Life Decoder</strong><br />
              Email: team@digitaldivecoaching.com<br />
              Address: No. H-8-2, Block H, Setiawalk Puchong, 47160 Selangor
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsOfServicePage;
